import styled, { css } from 'styled-components';
import { Theme } from '@/theme';

type InputFieldAttributes = {
  disabled?: boolean;
  width?: string;
};

export const InputField = styled.div(
  ({ width = '100%', disabled }: InputFieldAttributes) => css`
    border: 2px solid ${Theme.color.disabled};
    grid-template-columns: 40px 1fr 40px;

    border-radius: 30px;
    width: ${width};
    grid-gap: 10px;

    display: grid;
    padding: 6px;
    height: 56px;

    ${disabled &&
    css`
      background-color: ${Theme.color.disabledBg};
      color: ${Theme.color.black};
      pointer-events: none;
    `}
  `
);

export const InputPlaceholder = () => css`
  color: rgb(127 127 127);
  line-height: 1rem;
  font-size: 1rem;
  opacity: 0.5;
`;

type FieldContainerAttributes = {
  last?: boolean;
  width: number;
};

export const FieldContainer = styled.div(
  ({ width, last }: FieldContainerAttributes) => css`
    margin-bottom: 1em;
    position: relative;

    width: ${width}%;
    display: block;

    ${last &&
    css`
      margin-bottom: 0;
    `}
  `
);

export const FieldLabel = styled.label`
  font-size: ${Theme.rems(16)};
  color: ${Theme.color.text};

  margin-bottom: 2px;
  position: relative;
  line-height: 140%;

  display: block;
  width: 100%;
`;

type FieldErrorAttributes = {
  margin?: number | string;
};

export const FieldError = styled.span(
  ({ margin = 5 }: FieldErrorAttributes) => css`
    margin-top: ${margin}px;
    font-size: 0.875rem;

    color: rgb(191 0 0);
    position: relative;
    line-height: 1rem;

    display: block;
    width: 100%;
  `
);

export const FieldInput = styled.input`
  font-family: ${Theme.font.family.speedeeCondensed};
  font-weight: ${Theme.font.weight.bold};
  font-size: ${Theme.rems(28)};

  text-align: center;
  line-height: 90%;
  appearance: none;

  color: #595959;
  outline: none;
  border: none;
  width: 100%;
`;

type FieldControlAttributes = {
  disabled?: boolean;
};

export const FieldControl = styled.button(
  ({ disabled }: FieldControlAttributes) => css`
    box-shadow: 0px 2px 0px 0px rgb(0 0 0 / 0.3) inset;

    background-image: radial-gradient(
      50% 50% at 50% 50%,
      #ea282e 0%,
      #b80a0a 100%
    );

    justify-content: center;
    align-items: center;
    border-radius: 50%;

    display: flex;
    padding: 4px;
    border: none;

    height: 40px;
    width: 40px;

    ${disabled &&
    css`
      background-color: ${Theme.color.lightGrey};
      background-image: none;
      pointer-events: none;

      > svg > path {
        fill: ${Theme.color.disabled};
      }
    `}
  `
);
